module.exports = __webpack_public_path__ + "static/media/logo.55c7f3ac.svg";